import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { BrokerBanner } from '../../../components/BrokerBanner';
import { EAvailableBrokerFlow } from '../../../repositories/newbuilding-search/entities/newbuilding_broker/NewbuildingBrokerSchema';
import { getCurrentJsonQuery } from '../../../selectors/location';
import { getPageNewbuildingBroker } from '../../../selectors/broker';
import { getPartnerRewardsLanding, useBrokerAnalyticsUser } from '../../../utils/newbuildingBroker';
import { useNewbuildingBrokerContext } from '../../NewbuildingBrokerWidgetProvider';
import { trackBannerClick, trackBannerShown } from './tracking';

export function BrokerBannerContainer() {
  const jsonQuery = useSelector(getCurrentJsonQuery);
  const newbuildingBroker = useSelector(getPageNewbuildingBroker);
  const partnerRewardsLanding = getPartnerRewardsLanding(newbuildingBroker);

  const openWidget = useNewbuildingBrokerContext();

  const user = useBrokerAnalyticsUser(newbuildingBroker?.availableBrokerFlow as EAvailableBrokerFlow);

  const [loading, setLoading] = React.useState(false);

  const openLandingOrWidget = React.useCallback(async () => {
    if (partnerRewardsLanding) {
      window.open(partnerRewardsLanding, '_blank', 'noopener');
    } else {
      setLoading(true);

      await openWidget({
        flowType: newbuildingBroker?.availableBrokerFlow as EAvailableBrokerFlow,
        newbuildingId: null,
        newbuildingRegionId: null,
        houseId: null,
        isSelfEmployed: !!newbuildingBroker?.isNeedSelfEmployedConfirmation,
        trackingParams: {
          pageType: 'ListingJK',
          siteType: 'desktop',
          user,
        },
      });

      setLoading(false);
    }
  }, [newbuildingBroker, jsonQuery, openWidget, partnerRewardsLanding, user]);

  const handleBannerShown = React.useCallback(() => {
    trackBannerShown(jsonQuery, user);
  }, [jsonQuery, user]);

  const handleButtonClick = React.useCallback(async () => {
    trackBannerClick(jsonQuery, user);
    await openLandingOrWidget();
  }, [jsonQuery, openLandingOrWidget, user]);

  return (
    <ActionAfterViewObserver callback={handleBannerShown} triggerOnce>
      <BrokerBanner loading={loading} onClick={handleButtonClick} />
    </ActionAfterViewObserver>
  );
}
